import script from "./SAR.vue?vue&type=script&lang=js"
export * from "./SAR.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__